/**
 * Re-export du gestionnaire de tokens partage (@shared).
 * Ajoute la fonction logout() specifique au module auth
 * (nettoyage user + store Zustand persiste).
 */

export {
  TokenManager,
  tokenManager,
  isAuthenticated,
  getCurrentUser,
} from '@shared/infrastructure/security';
export type { JWTPayload } from '@shared/infrastructure/security';

import { tokenManager } from '@shared/infrastructure/security';
import { authStorage } from './storage';

/**
 * Deconnecte l'utilisateur : nettoie tokens + donnees user + store Zustand persiste.
 */
export function logout(): void {
  tokenManager.clearTokens();
  authStorage.clearUser();
  if (typeof window !== 'undefined') {
    localStorage.removeItem('caritas-auth-storage');
  }
}
